export function MyInterviewFilledSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/my-interview-filled.svg'"></ng-include>`
    }
}